import {Store} from "../../../stem-core/src/state/Store";

/* TODO: Remove this in the future.
    this is required because the ws server does not guarantee the order of
    subscription status updates - ACTIVE status may be received before
    PENDING
*/
export const PaymentStatusDependentStore = (...args) =>
    class PaymestStatusStore extends Store(...args) {
        importState(objects) {
            objects = objects || [];
            for (const obj of objects) {
                const subscription = this.get(obj.id);
                if (!this.shouldSkipUpdate(subscription, obj)) {
                    super.importState([obj]);
                }
            }
        }

        applyEvent(event) {
            const obj = this.getObjectForEvent(event);

            if (this.shouldSkipUpdate(obj, event.data)) {
                event.data = obj;
            }
            return super.applyEvent(event);
        }

        shouldSkipUpdate(obj, updateObj) {
            return !updateObj;
        }
    };
